
import { Vue, Component, Ref } from 'vue-property-decorator';
import { FormModel } from 'ant-design-vue';
import SPUService from '@/services/spu.service';
import lazyInject from '@/di';

@Component
export default class ImageManagementModal extends Vue {
  @lazyInject(SPUService)
  protected spuService!: SPUService;

  visible = false;

  visibleModal = false;

  labelCol = { span: 6 };

  wrapperCol = { span: 12 };

  typeItem = 'add';

  categoryName = '';

  @Ref('formModel')
  formModel!: FormModel;

  titleText = '商品图片分类管理';

  pagination = {
    total: 0,
    current: 1,
    pageSize: 10,
    onChange: this.onChangePage,
    showSizeChanger: true,
    pageSizeOptions: this.$store.state.pageSize.pageSize,
    onShowSizeChange: this.onShowSizeChange,
  };

  form: any = {
    photo_type_name: '',
    cate_id: '',
  };

  rules: any = {
    photo_type_name: [
      { required: true, message: '请输入图片分类名称', trigger: 'blur' },
    ],
  };

  columns = [
    {
      title: '商品类目',
      dataIndex: 'categoryName',
      key: 'categoryName',
      align: 'center',
      scopedSlots: { customRender: 'categoryName' },
    },
    {
      title: '图片分类名称',
      dataIndex: 'photo_type_name',
      key: 'photo_type_name',
      align: 'center',
    },
    {
      title: '创建时间',
      dataIndex: 'created_at',
      key: 'created_at',
      align: 'center',
    },
    {
      title: '创建人',
      dataIndex: 'operator_name',
      key: 'operator_name',
      align: 'center',
    },
    {
      title: '操作',
      dataIndex: 'action',
      key: 'action',
      align: 'center',
      scopedSlots: { customRender: 'action' },
    },
  ];

  data = [];

  onChangePage(page: number, pageSize: number) {
    this.pagination.current = page;
    this.pagination.pageSize = pageSize;
    this.getPhotoList();
  }

  addImageManagement() {
    // console.log('新增分类');
    this.typeItem = 'add';
    this.visibleModal = true;
  }

  deleteItem(item: any) {
    // console.log('删除分类', item);
    this.$confirm({
      title: '提示',
      content: '确定要删除该分类吗？',
      onOk: async () => {
        const { id } = item;
        const data = {
          photo_type_id: id,
          is_del: 1,
        };
        const res = await this.spuService.postCategoryPhotoEditType(data);
        if (res) {
          this.$message.success('操作成功');
          this.getPhotoList();
        }
        return true;
      },
      onCancel() {},
    });
  }

  editItem(item: any) {
    this.form.photo_type_name = item.photo_type_name;
    this.form.photo_type_id = item.id;
    this.typeItem = 'edit';
    this.visibleModal = true;
  }

  onShowSizeChange(current: number, size: number) {
    this.pagination.current = 1;
    this.pagination.pageSize = size;
    this.getPhotoList();
  }

  init(val: any, v: any) {
    // this.visible = val;
    this.pagination.current = 1;
    this.pagination.pageSize = 10;
    this.titleText = `商品图片分类管理 - (${val.pName}-${v.name})`;
    this.categoryName = `${val.pName}-${v.name}`;
    this.form.cate_id = v.id;
    this.visible = true;
    this.getPhotoList();
  }

  async getPhotoList() {
    const data = {
      page: this.pagination.current,
      pageSize: this.pagination.pageSize,
      cate_id: this.form.cate_id,
    };
    const res = await this.spuService.getSpuCategoryPhotoList(data);
    this.data = res.list;
    this.pagination.total = res.total;
  }

  onClose() {
    this.visible = false;
  }

  handleOk() {
    this.formModel.validate(async (valid: boolean) => {
      if (valid) {
        if (this.typeItem === 'edit') {
          const { cate_id, photo_type_name, photo_type_id } = this.form;
          const data = {
            cate_id,
            photo_type_name,
            photo_type_id,
          };
          const res = await this.spuService.postCategoryPhotoEditType(data);
          if (res) {
            this.$message.success('操作成功');
            this.getPhotoList();
            this.visibleModal = false;
          }
        } else {
          const { cate_id, photo_type_name } = this.form;
          const data = {
            cate_id,
            photo_type_name,
          };
          const res = await this.spuService.postSpuCategoryPhotoCreate(data);
          if (res) {
            this.form.photo_type_name = '';
            this.$message.success('操作成功');
            this.getPhotoList();
            this.visibleModal = false;
          }
        }
      } else {
        return false;
      }
    });
  }

  handleCancel() {
    this.formModel.resetFields();
    this.visibleModal = false;
  }
}
